import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=6067c72f&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067c72f",
  null
  
)

export default component.exports